<template>
  <ui-component-modal
    modalTitle=""
    :isSaving="isSaving"
    :isSavingSuccess="isSavingSuccess"
    :isSavingError="isSavingError"
    :hideFooterButtons="isSavingError || isSavingSuccess"
    :onClickCancel="onClickCancel"
    :onClickSave="saveSubscription"
    :showModal="showModal"
    @closeModal="onClickCancel"
  >
    <template slot="modalTitle"></template>
    <template v-slot:content>
      <section class="section">
        <div class="container">
          <table v-if="mSubscription" class="table is-fullwidth is-striped">
            <tbody>
              <tr>
                <td>Channel</td>
                <td width="250">{{ mSubscription.ChannelName }}</td>
              </tr>
              <tr>
                <td>Package</td>
                <td>{{ mSubscription.PackageName }}</td>
              </tr>
              <tr>
                <td>Period</td>
                <td>
                  {{ mSubscription.Month | getMonthName }}
                  {{ subscription.Year }}
                </td>
              </tr>
              <tr>
                <td>Monthly fixed fee</td>
                <td>
                  <div class="field has-addons">
                    <p class="control">
                      <a class="button is-static">&euro;</a>
                    </p>
                    <p class="control">
                      <input
                        type="text"
                        v-model.number="mSubscription.Price"
                        class="input"
                      />
                    </p>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </section>

      <section v-if="hasMeetingspace" class="section">
        <div class="container">
          <table v-if="mSubscription" class="table is-fullwidth is-striped">
            <tbody>
              <tr>
                <td>Meetingspace fee</td>
                <td width="250">
                  <div class="field has-addons">
                    <p class="control">
                      <a class="button is-static">&euro;</a>
                    </p>
                    <p class="control">
                      <input
                        type="text"
                        v-model.number="mSubscription.SeatFeeMS"
                        class="input"
                      />
                    </p>
                  </div>
                </td>
              </tr>
              <tr v-if="hasMeetingspace">
                <td>Meetingspace max. fee seats</td>
                <td>
                  <div class="field has-addons">
                    <p class="control">
                      <a class="button is-static">&euro;</a>
                    </p>
                    <p class="control">
                      <input
                        type="text"
                        v-model.number="mSubscription.MaxSeatFeeTotalMS"
                        class="input"
                      />
                    </p>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </section>

      <section v-if="hasWorkspace" class="section">
        <div class="container">
          <table v-if="mSubscription" class="table is-fullwidth is-striped">
            <tbody>
              <tr>
                <td>Workspace fee</td>
                <td width="250">
                  <div class="field has-addons">
                    <p class="control">
                      <a class="button is-static">&euro;</a>
                    </p>
                    <p class="control">
                      <input
                        type="text"
                        v-model.number="mSubscription.SeatFeeWS"
                        class="input"
                      />
                    </p>
                  </div>
                </td>
              </tr>
              <tr>
                <td>Workspace max. fee seats</td>
                <td>
                  <div class="field has-addons">
                    <p class="control">
                      <a class="button is-static">&euro;</a>
                    </p>
                    <p class="control">
                      <input
                        type="text"
                        v-model.number="mSubscription.MaxSeatFeeTotalWS"
                        class="input"
                      />
                    </p>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </section>

      <section class="section">
        <div class="container">
          <table v-if="mSubscription" class="table is-fullwidth is-striped">
            <tbody>
              <tr>
                <td>Billable</td>
                <td width="250">
                  <input
                    type="checkbox"
                    v-model="mSubscription.SendInvoice"
                    id="freeTrial"
                    class="checkbox"
                  />
                </td>
              </tr>

              <tr>
                <td>Free trial</td>
                <td>
                  <input
                    type="checkbox"
                    v-model="mSubscription.IsTrial"
                    id="freeTrial"
                    class="checkbox"
                  />
                </td>
              </tr>

              <tr>
                <td>Recurring</td>
                <td>
                  <input
                    type="checkbox"
                    v-model="mSubscription.IsRecurring"
                    id="freeTrial"
                    class="checkbox"
                  />
                </td>
              </tr>

              <tr>
                <td>Cancelled</td>
                <td>
                  <input
                    type="checkbox"
                    v-model="mSubscription.IsCancelled"
                    id="freeTrial"
                    class="checkbox"
                  />
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </section>
    </template>
  </ui-component-modal>
</template>

<script>
import Vue from 'vue'
import { mapState, mapMutations } from 'vuex'
import { EventBus } from '@/eventbus/event-bus'
import subscriptionProvider from '@/providers/subscription'

export default {
  components: {},

  props: {
    showModal: {
      type: Boolean,
      default: false,
    },

    onClickCancel: {
      type: Function,
      required: true,
    },

    subscription: {
      type: Object,
      default: null,
    },
  },

  data() {
    return {
      isSaving: false,
      isSavingSuccess: false,
      isSavingError: false,
      mSubscription: null,
    }
  },

  computed: {
    ...mapState('locationStore', ['locationState']),

    hasMeetingspace() {
      let result = false

      if (this.locationState) {
        result =
          this.locationState.Meetingtypes.findIndex(
            (m) => m.MeetingtypeId === 1
          ) > -1
      }

      return result
    },

    hasWorkspace() {
      let result = false

      if (this.locationState) {
        result =
          this.locationState.Meetingtypes.findIndex(
            (m) => m.MeetingtypeId === 2
          ) > -1
      }

      return result
    },
  },

  created() {
    this.mSubscription = JSON.parse(JSON.stringify(this.subscription))
  },

  methods: {
    saveSubscription() {
      let self = this

      if (!self.isSaving) {
        self.isSaving = true

        subscriptionProvider.methods
          .updateSubscription(this.mSubscription)
          .then((response) => {
            if (response.status === 200) {
              self.$emit('subscriptionUpdated', this.mSubscription)

              self.onClickCancel()
            }
          })
          .catch((e) => {
            self.isSavingError = true
          })
          .finally(() => {
            self.isSaving = false
          })
      }
    },
  },
}
</script>
